// Path → icon for the sidebar. Kept out of lib/nav/*.ts (pure, Vitest-tested
// data modules) so those stay free of JSX.
import type { ReactNode } from 'react';
import { CalendarIcon } from '@/icons';
import {
  BuildIcon,
  BusinessIcon,
  CashIcon,
  DocumentIcon,
  GridIcon,
  ListIcon,
  MegaphoneIcon,
  PeopleIcon,
  PricetagIcon,
  PulseIcon,
  QrIcon,
  RestaurantIcon,
  ShieldIcon,
  StarIcon,
  WalletIcon,
} from '@/icons/nav';

const ICONS: Record<string, ReactNode> = {
  '/': <GridIcon />,
  '/check-in': <QrIcon />,
  '/bookings': <ListIcon />,
  '/bookings/calendar': <CalendarIcon />,
  '/rates': <PricetagIcon />,
  '/listings': <BusinessIcon />,
  '/settlement': <WalletIcon />,
  '/statements': <DocumentIcon />,
  '/reviews': <StarIcon />,
  '/verification': <ShieldIcon />,
  '/team': <PeopleIcon />,
  '/reservations': <RestaurantIcon />,
  '/pro': <StarIcon />,
  '/featured': <MegaphoneIcon />,
  '/verified-badge': <ShieldIcon />,
  '/channels': <CalendarIcon />,
  // admin
  '/approvals': <ShieldIcon />,
  '/webhooks': <PulseIcon />,
  '/hosts': <BusinessIcon />,
  '/guests': <PeopleIcon />,
  '/content': <MegaphoneIcon />,
  '/finance': <CashIcon />,
  '/ops': <BuildIcon />,
};

export function navIconFor(to: string): ReactNode {
  return ICONS[to] ?? <ListIcon />;
}
